module.exports = __webpack_public_path__ + "static/media/majorE4.144ad81.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorE4.wav
// module id = IZuE
// module chunks = 0